import React, { useState } from "react";

export default function Form() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    companyName: "",
    message: "",
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        "form-name": "contact",
        ...formData,
      }).toString(),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Form submission failed");
        }
        setIsSubmitted(true);
        setFormData({
          fullName: "",
          email: "",
          companyName: "",
          message: "",
        });
      })
      .catch(() => {
        setError(
          "Something went wrong. Please try again or email charles@charismaticconsultingandservices.com directly."
        );
      });
  };

  React.useEffect(() => {
    if (isSubmitted) {
      setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);
    }
  }, [isSubmitted]);

  return (
    <form
      onSubmit={handleSubmit}
      className="py-4 flex-col justify-start items-start gap-[27px] flex w-full relative"
      name="contact"
      method="POST"
      data-netlify="true"
      netlify-honeypot="bot-field"
    >
      {/* Netlify form detection */}
      <input type="hidden" name="form-name" value="contact" />

      {/* Honeypot field for spam protection */}
      <div className="hidden">
        <input name="bot-field" />
      </div>

      <div className="flex-col justify-start items-start gap-6 flex w-full">
        <div className="flex-col justify-start items-start gap-1 flex w-full lg:max-w-[499px]">
          <div className="text-[#0e0e0e] text-base md:text-lg font-normal font-primary leading-[22.40px] tracking-[0.01em]">
            Full Name
          </div>
          <input
            required
            type="text"
            name="fullName"
            className="w-full p-4 bg-white rounded-md border border-[#d0d4dd] justify-start items-center gap-3 inline-flex"
            placeholder="Enter full name"
            value={formData.fullName}
            onChange={(e) =>
              setFormData({ ...formData, fullName: e.target.value })
            }
          />
        </div>
        <div className="flex-col justify-start items-start gap-1 flex w-full lg:max-w-[499px]">
          <div className="text-[#0e0e0e] text-base md:text-lg font-normal font-primary leading-[22.40px] tracking-[0.01em]">
            Email
          </div>
          <input
            required
            type="text"
            pattern="[A-Za-z0-9._+\-']+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}"
            name="email"
            className="w-full p-4 bg-white rounded-md border border-[#d0d4dd] justify-start items-center gap-3 inline-flex"
            placeholder="Enter Email"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
        </div>
        <div className="flex-col justify-start items-start gap-1 flex w-full lg:max-w-[499px]">
          <div className="text-[#0e0e0e] text-base md:text-lg font-normal font-primary leading-[22.40px] tracking-[0.01em]">
            Company Name (optional)
          </div>
          <input
            type="text"
            name="companyName"
            className="w-full p-4 bg-white rounded-md border border-[#d0d4dd] justify-start items-center gap-3 inline-flex"
            placeholder="Enter Company Name"
            value={formData.companyName}
            onChange={(e) =>
              setFormData({ ...formData, companyName: e.target.value })
            }
          />
        </div>
        <div className="flex-col justify-start items-start gap-1 flex w-full lg:max-w-[499px]">
          <div className="text-[#0e0e0e] text-base md:text-lg font-normal font-primary leading-[22.40px] tracking-[0.01em]">
            Message
          </div>
          <textarea
            required
            name="message"
            className="w-full p-4 bg-white rounded-md border border-[#d0d4dd] justify-start items-center gap-3 inline-flex"
            placeholder="Enter Message"
            rows={4}
            style={{ resize: "none" }}
            value={formData.message}
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
          />
        </div>
      </div>
      <button
        className="text-white font-semibold font-primary leading-5 max-h-[44px] p-3 bg-[#0075ff] disabled:opacity-50 
        rounded justify-center items-center gap-1.5 inline-flex hover:bg-[#0E0E0E] transition-all duration-300"
        type="submit"
        disabled={isSubmitted}
      >
        {isSubmitted ? "Submitted" : "Submit Inquiry"}
      </button>
      {isSubmitted && (
        <div className="absolute bottom-[-25px] md:bottom-[-75px] left-0 right-0 w-full opacity-100 text-green-600 text-base md:text-lg font-light font-primary leading-7 tracking-[0.01em]">
          Thank you for reaching out! Charles Bell will respond to your inquiry
          within 24–48 hours.
        </div>
      )}
      {error && (
        <div className="absolute bottom-[-25px] md:bottom-[-75px] left-0 right-0 w-full opacity-100 text-red-600 text-base md:text-lg font-light font-primary leading-7 tracking-[0.01em]">
          {error}
        </div>
      )}
    </form>
  );
}
